import { queryOptions } from '@tanstack/react-query';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { TabelaPrecoProdutoSchema } from '../types/TabelaPrecoProduto';

type TabelaPrecoProdutoParams = {
    produto_idpk: number;
    tabela_preco_idpk?: number;
};

const schema = registrosSchema(TabelaPrecoProdutoSchema);

function apiTabelaPrecoProduto(params: TabelaPrecoProdutoParams) {
    return fetchApi({
        endpoint: 'TabelaPreco/Produto',
        method: 'get',
        params,
        schema,
    });
}

export const API_TABELA_PRECO_PRODUTO_KEY = 'apiTabelaPrecoProduto';

export function apiTabelaPrecoProdutoQueryOptions(params: TabelaPrecoProdutoParams) {
    return queryOptions({
        queryFn: () => apiTabelaPrecoProduto(params),
        queryKey: [API_TABELA_PRECO_PRODUTO_KEY, params],
    });
}
